import React from 'react';

import { StarMark } from 'components/common/StarMark/StarMark';

export const RECOMMENDED_LABEL = 'Top pick';

export const RecommendedStar: React.FC = () => (
  <StarMark label={RECOMMENDED_LABEL} color="text.brand" />
);
